import {
    Box,
    Image,
    Step,
    StepDescription,
    StepIndicator,
    StepSeparator,
    StepStatus,
    StepTitle,
    Stepper,
    Text,
    Textarea,
  } from "@chakra-ui/react";
  import React, { useEffect, useRef, useState } from "react";
  import { EditCCCall, FetchChiefComplaint } from "../../middleware/services/messages";
  import moment from "moment";
  import useLoader from "../../components/loader/loaderstates";
  import Loader from "../../components/loader/loader";
  import { useLocation, useNavigate } from "react-router-dom";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import DynamicModal from "../../components/dynamic-modal";
import { DropdownInput, PrimaryButton, PrimaryInput, Toaster } from "../../components";
import DatePicker from "../../components/date-picker";
import { FetchDoctorsByUser, FetchUsersByClinic } from "../../middleware/services/home";
import { useGPUTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useGPUTranscriber";
import { useForm } from "react-hook-form";
import { CorrectChiefComplaintUsingAI, CorrectMedicalTermsUsingAI } from "../../middleware/services/visits/aicalls";
import { GPUChatAudioManager } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManager";
import { getIsDoctor, getLoginID } from "../../auth";
import { useHybridTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useHybridTranscriber";
import { GPUChatAudioManagerSpeechMode } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManagerSpeechMode";
  
  
const ChiefComplaint = ({id,backFunction,doctorId,appointmentId}) => {

  const location = useLocation();
  const [patientid, setPatientid] = useState("");
  const [apmtIdUrl, setApmtIdUrl] = useState("");
  const [chiefComplaintData, setChiefComplaintData] = useState(null);
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();
  const navigate = useNavigate()

  useEffect(() => {
    const currentUrl = window.location.href;
    const searchParams = new URLSearchParams(currentUrl.split('?') [1]);
    const id = searchParams.get('id');
    const apmtid = searchParams.get('appointmentid');
    setPatientid(id);

    if (apmtid) {
    setApmtIdUrl(apmtid);
  }

  if(apmtid) {
      fetchcheifcomplaintdata(id, apmtid)
    } else {
      fetchcheifcomplaintdata(id, "")
    }
    
    // fetchcheifcomplaintdata(id)   
  }, []);
  
  const fetchcheifcomplaintdata = async (id, apmtid="") => {
    showLoader()
        try {
          const result = await FetchChiefComplaint({
            patientid: id,
            ...(apmtid && { appointmentid: apmtid }), 
            ...(apmtid && { type: 'ipd' })
          });

          if (result != null) {
            console.log(result)
            setChiefComplaintData(result);
          } else {
          }
          dismissLoader()
      } catch (error) {
          console.error("Error in home:", error);
        }
      };

      const formatDate = (dateString) => {
        if (!dateString) return "-";
        return moment(dateString).format("Do MMM, YYYY");
      };

      // console.log(patientid, "chiefComplaint IDDDDD")
      // console.log(chiefComplaintData, "chiefComplaint Dataaaaaaa")

// --------------- Edit Complaint Functionality ---------------------------
const editComplaint = useRef();
var [DoctorListForDropdown, setDoctorListForDropdown] = useState([]);
var [DoctorList, setDoctorList] = useState([]);
var [Doctorid, setDoctorid] = useState(null);
var [DefaultDoctor, setDefaultDoctor] = useState(null);
const [updateCC, setUpdateCC] = useState('')

// Function to extract comma-separated specialties from doctorspeciality array
const getCommaSeparatedSpecialties = (specialtiesArray) => {
  if (!specialtiesArray || !Array.isArray(specialtiesArray)) {
    return "";
  }
  
  // Extract specialityname from each object and filter out null/undefined values
  const specialtyNames = specialtiesArray
    .map(specialty => {
      if (specialty?.specialityname === "Other" && specialty?.othervalue) {
        // Use othervalue when specialityname is "Other" and othervalue exists
        return specialty.othervalue;
      } else {
        // Use specialityname for all other cases
        return specialty?.specialityname;
      }
    })
    .filter(name => name != null && name.trim() !== "");
  
  return specialtyNames.join(", ");
};

const [doctorSpecialties, setDoctorSpecialties] = useState("");
// Updated fetchDoctors function with specialty handling
const fetchDoctors = async () => {
  showLoader();
  try {
    const result = await FetchUsersByClinic({
      appointmentid: apmtIdUrl,
    });

    if (result.output.result == "success") {
      console.log('result.output.data: ', result.output.data);
      
      // Process doctors with specialties
      const processedDoctors = result.output.data.map(doctor => ({
        ...doctor,
        specialtiesString: getCommaSeparatedSpecialties(doctor.doctorspeciality)
      }));
      
      setDoctorList(processedDoctors);
      
      const Doctors = processedDoctors.map((doctor) => [
        doctor.fullname
      ]);
      console.log('Doctors: ', Doctors);
      setDoctorListForDropdown(Doctors);
      
      const currentdoctor = getIsDoctor();
      console.log('currentdoctor: ', currentdoctor);
      const loginid = getLoginID();
      console.log('getLogin: ', loginid);
      
      let obj = {};
      if (currentdoctor == 1 && currentdoctor != null) {
        obj = processedDoctors.filter(doctor => doctor.doctorid == loginid);
        if (obj[0]) {
          console.log('obj[0]: ', obj[0].fullname);
          setDefaultDoctor(obj[0].fullname);
          setDoctorid(loginid);
          // Set specialties for the current doctor
          setDoctorSpecialties(obj[0].specialtiesString);
        }
      } else {
        setDefaultDoctor("");
        // Reset specialties if no current doctor
        setDoctorSpecialties("");
      }
    } else {
      setDoctorList([]);
      dismissLoader();
    }
    dismissLoader();
  } catch (error) {
    console.error("Error", error);
  }
};
// const fetchDoctors = async () => {
//     showLoader();
//     try {
//       const result = await FetchUsersByClinic({
//         doctorId,
//         appointmentId
//       });

//       // console.log('resultofDoctors: ', result)
//       if (result.output.result == "success") {
//         // console.log('result.outptu.data: ', result.output.data)
//         setDoctorList(result.output.data);
//         const Doctors = result.output.data && result.output.data.map((step) => [
//           step.fullname
//         ]);
//         // console.log('Doctors: ', Doctors)
//         setDoctorListForDropdown(Doctors);
//         const currentdoctor = getIsDoctor();
//         // console.log('currentdoctor: ', currentdoctor)
//         const loginid = getLoginID()
//         let obj = {}
//         if (currentdoctor == 1 && currentdoctor != null) {
//           obj = result.output.data && result.output.data.filter(doctor => doctor.doctorid == loginid);
//           if (obj[0]) {
//             // console.log('obj[0]: ', obj[0].fullname)
//             setDefaultDoctor(obj[0].fullname)
//             setDoctorid(obj[0].doctorid);
//           }
//         } else {
//           setDefaultDoctor("");
//         }
//       } else {
//         setDoctorList([]);
//         dismissLoader();
//       }
//       dismissLoader();
//     } catch (error) {
//       console.error("Error", error);
//     }
//   };
  const HandleEditDoctor = (selectedOption) => {
    let obj = DoctorList.filter(doctor => doctor.fullname == selectedOption);
    console.log('obj: ', obj)
    setDoctorid(obj[0].doctorid)
    console.log('obj[0].doctorid: ', obj[0].doctorid)
    setEditData(prev => ({
      ...prev,
      doctorName: obj[0].fullname,
      updatedby: obj[0].doctorid, 
      updatedbyid: obj[0].doctorid,
      doctorspecialties: obj[0].specialtiesString
    }));
    // Also update the global doctorSpecialties state
    setDoctorSpecialties(obj[0].specialtiesString);
  }

  //Remove speech and keep Null to toggle between GPU and Speech
  const { transcriber: activeTranscriber, mode } =
    useHybridTranscriber("speech", (text) => {
      // called when speech recognition finishes
      setPlaceholder(text || "");
      setTyping(false);
  });
  
  const [typing, setTyping] = useState(false); // Typing indicator state
  const [HPITextBox, SetHPITextBox] = useState("");

  const [placeholder, setPlaceholder] = useState(
    "Click anywhere to start typing...."
  );

  useEffect(() => {
    if (activeTranscriber?.output?.text) {
  const transcribedText = activeTranscriber.output.text;
  setValue("textField", transcribedText);
  setUpdateCC(transcribedText); // Add this line to update the CC state
    setEditData(prev => ({...prev, chiefcomplaint: transcribedText}));
  // setAddGeneralDoctorNotes(transcribedText); // Update the state with transcribed text
  setPlaceholder("Click anywhere to start typing...."); // Clear the placeholder when text exists
  setPlaceholder(""); // Clear the placeholder when text exists
  setTyping(false);
}
      // if (activeTranscriber?.output?.text) {
      //   setValue("textField", activeTranscriber.output.text);
  
      //   // setPlaceholder("Click anywhere to start typing....");
      //   setPlaceholder("Instructions");
      //   setTyping(false);
      // }
    }, [activeTranscriber?.output]);

    // Handle text changes in the textarea
const handleTextChange = (e) => {
const text = e.target.value;
setUpdateCC(text);
setValue("textField", text); // Keep form value in sync
setEditData(prev => ({...prev, chiefcomplaint: text}));
setPlaceholder(text ? "" : "Click anywhere to start typing...."); // Show placeholder only when empty
};

  const { register, handleSubmit, watch, setValue } = useForm();
  const textFieldValue = watch("textField", "");
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [initialText, setInitialText] = useState("");

  const onSubmit = (data) => {
      setIsButtonDisabled(true); // Disable button on submit
      // UpdateHpiTextBox(data);
      SetHPITextBox(data);
      // fetchDoctorNotesEmptyIndication();
    };
  
      // submit on tab switch and submit button is enalbed
      useEffect(()=>{
          if(!isButtonDisabled){
          handleSubmit(onSubmit)();
          }
      },[])
  
    useEffect(() => {
      if (textFieldValue !== initialText) {
        setIsButtonDisabled(false); // Enable button if text field value changes
      } else {
        setIsButtonDisabled(true); // Disable button if text field value is unchanged
      }
    }, [textFieldValue, initialText]);

    const correctOrders = async (formType) => {
        const currentText = watch("textField");
        
        if (!currentText) {
          showErrorToast("No text available to correct");
          return;
        }
    
        console.log('cc specialirts: ', doctorSpecialties)
        const inputToSave = {
          input: {
            text: currentText,
            // type: `cc#${doctorSpecialties}#${noteType}#${doctorExperience}#${inpLang}#${outLang}`,
            // type: `cc#ayurvedic, Psychiatry#Consultation Note#99#hindi#english`,
          },
        };
    
        showLoader();
        try {
          // const result = await CorrectMedicalTermsUsingAI(inputToSave);
          const result = await CorrectChiefComplaintUsingAI(inputToSave.input);
          if (result) {
            showSuccessToast("Updated Text");
            const updatedText = result?.text;
    
            // Update form value
            setValue("textField", updatedText, {
              shouldDirty: true,
              shouldTouch: true,
              shouldValidate: true,
            });
            setUpdateCC(updatedText);
      setEditData(prev => ({...prev, chiefcomplaint: updatedText}));
      setIsButtonDisabled(false);
      setPlaceholder("");
    
    console.log('updatedText: ', updatedText)
            
            // Update the appropriate state based on form type
            // if (formType === "add") {
            //   setAddGeneralDoctorNotes(updatedText);
            // } else {
              // handleEditMedicineChange("custommessage", updatedText);
              // setUpdateCC(updatedText);
            // }
            
            // setIsButtonDisabled(false);
          }
        } catch (error) {
          console.error("Error in Correct AI call:", error);
          showErrorToast("Error Happened While Correcting.");
        } finally {
          dismissLoader();
        }
    };

  // const [date, setDate] = useState('');
  // const [time, setTime] = useState('');
  // const [date, setDate] = useState(moment().format("DD-MM-yyyy"));
  // const [time, setTime] = useState(moment().format("HH:mm"));

  const getLocalISOString = (dateStr, timeStr) => {
    // Parse the date in DD-MM-yyyy format
    const [day, month, year] = dateStr.split("-").map(Number);
    // Parse the time in HH:mm format
    const [hours, minutes] = timeStr.split(":").map(Number);
    
    // Create a Date object in local timezone
    const dateObj = new Date(year, month - 1, day, hours, minutes, 0);
    
    // Format to ISO string with local timezone offset
    const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // offset in milliseconds
    const localISOTime = new Date(dateObj - timezoneOffset).toISOString().slice(0, 19).replace('Z', '');
    
    return localISOTime;
  };

 const handledatechange = (selectedDate) => {
  const formattedDate = moment(selectedDate).format("DD-MM-yyyy");
  setEditData(prev => ({...prev, date: formattedDate}));
};

// existing function
// const handleTimeChange = (event) => {
//   const inputTime = event.target.value;
//   const currentTime = new Date();
//   const [inputHours, inputMinutes] = inputTime.split(":").map(Number);

//   const inputDate = new Date();
//   inputDate.setHours(inputHours);
//   inputDate.setMinutes(inputMinutes);

//   if (inputDate > currentTime) {
//     const currentFormattedTime = moment().format("HH:mm");
//     setEditData(prev => ({...prev, time: currentFormattedTime}));
//     showErrorToast("Future time cannot be selected.");
//   } else {
//     setEditData(prev => ({...prev, time: inputTime}));
//   }
// };
const handleTimeChange = (event) => {
  const inputTime = event.target.value;
  const currentDate = moment().format("DD-MM-yyyy");
  const currentTime = moment().format("HH:mm");
  
  // Only validate if the selected date is today
  if (editData.date === currentDate) {
    const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
    const [currentHours, currentMinutes] = currentTime.split(":").map(Number);

    // Create moment objects for comparison
    const inputMoment = moment().set({
      hour: inputHours,
      minute: inputMinutes,
      second: 0,
      millisecond: 0
    });
    
    const currentMoment = moment();

    if (inputMoment.isAfter(currentMoment)) {
      setEditData(prev => ({...prev, time: currentTime}));
      showErrorToast("Future time cannot be selected.");
      return;
    }
  }
  
  // If date is not today or time is not in future, update the time
  setEditData(prev => ({...prev, time: inputTime}));
};

  const [editData, setEditData] = useState({
  appointmentid: "",
  doctorid: "",
  patientid: "",
  chiefcomplaint: "",
  date: moment().format("DD-MM-yyyy"),
  time: moment().format("HH:mm"),
  doctorName: "",
  updatedby: "",
  updatedbyid: "" 
});

const openEditModal = (details) => {
  console.log('details::::< ', details)
  // Convert the appointment datetime to local format
  // const appointmentDate = moment(details.appointmentdatetime).format("DD-MM-yyyy");
  // const appointmentTime = moment(details.appointmentdatetime).format("HH:mm");
  // const appointmentMoment = moment(details.updateddate);

  let appointmentMoment;
  try {
    // Check if updateddate is null, then use current date & time
    if (details.updateddate === null) {
      appointmentMoment = moment(); // Current date & time
    } else {
      // Use updateddate if available, otherwise appointmentdatetime
      appointmentMoment = moment(details.updateddate || details.appointmentdatetime || new Date());
      if (!appointmentMoment.isValid()) {
        appointmentMoment = moment(); // Fallback to current date
      }
    }
  } catch (e) {
    appointmentMoment = moment(); // Fallback to current date
  }
  // try {
  //   // appointmentMoment = moment(details.updateddate || details.appointmentdate || new Date());
  //   appointmentMoment = moment(details.updateddate || details.appointmentdatetime || new Date());
  //   if (!appointmentMoment.isValid()) {
  //     appointmentMoment = moment(); // Fallback to current date
  //   }
  // } catch (e) {
  //   appointmentMoment = moment(); // Fallback to current date
  // }
  
  // Determine which doctor name to display
  const displayDoctorName = typeof details.updatedby === 'string' && details.updatedby !== '' 
    ? details.updatedby 
    : details.doctorname;

  // Set all the edit data
  setEditData({
    appointmentid: details.appointmentid,
    doctorid: details.updatedbyid || details.doctorid, // Use updatedbyid if available
    patientid: details.patientid,
    chiefcomplaint: details.chiefcomplaint || "",
    date: appointmentMoment.format("DD-MM-yyyy"),
    time: appointmentMoment.format("HH:mm"), // Get time from the date
    doctorName: displayDoctorName,
    updatedby: details.updatedbyid || details.doctorid,
    updatedbyid: details.updatedbyid || details.doctorid,
  });

  // Set the chief complaint text
  setUpdateCC(details.chiefcomplaint || "");
  setValue("textField", details.chiefcomplaint || "");

  // Set default doctor for dropdown
  setDefaultDoctor(displayDoctorName);
  setDoctorid(details.updatedbyid || details.doctorid);
  fetchDoctors();
  
  editComplaint.current.openModal();
};

   const editChiefComplaint = async () => {
      const updatedDateTime = getLocalISOString(editData.date, editData.time);
    
    const inputToUpdate = {
    input: {
      // doctorid: editData.doctorid.toString(),
      patientid: editData.patientid,
      appointmentid: editData.appointmentid,
      chiefcomplaint: editData.chiefcomplaint,
      updatedby: editData.updatedbyid || editData.doctorid,
      updateddate: updatedDateTime,
    }
  };

      try {
        const result = await EditCCCall(inputToUpdate.input);
        setUpdateCC('')
        showSuccessToast("Chief Complaint Updated Successfully")
        if(apmtIdUrl) {
          fetchcheifcomplaintdata(patientid, apmtIdUrl)
        }else {
          fetchcheifcomplaintdata(patientid)
        }
        editComplaint.current.closeModal();
        return result;
      } catch (error) {
        console.log('Error in updating Dietician notes', error)
        throw error;
      }
    }
  // const editChiefComplaint = async () => {
  //   const inputToUpdate = {
  //     input: {
  //       appointmentid: appointmentId,
  //       // doctorid: doctorId,
  //       id: generalEditNotesId,
  //       generalnote: updateCC
  //     }
  //   }

  //   try {
  //     const result = await EditDoctorNotes(inputToUpdate.input);
  //     setUpdateCC('')
  //     showSuccessToast("Notes Updated Successfully")
  //     if(appointmentId) {
  //       fetchdoctornotesdata(patientid, appointmentId)
  //     }else {
  //       fetchdoctornotesdata(patientid)

  //     }
  //     return result;
  //   } catch (error) {
  //     console.log('Error in updating Dietician notes', error)
  //     throw error;
  //   }
  // }

  const deleteModal = useRef();
  const [deleteId, setDeleteId] = useState(null)
  const openDeleteModal = (id) => {
        setDeleteId(id);
        deleteModal.current.openModal();
      };
  
      const handleConfirmDelete = async () => {
        if (!deleteId) return;
  
        const input = {
          // doctorid: doctorId,
          patientid: patientid,
          appointmentid: apmtIdUrl,
          id: deleteId,
          isactive: 0,
        //   hpitext: [{
        // }]
        };
  
        showLoader();
        try {
          const req = await EditCCCall(input);
          if (req.output.result === "success") {
            if (apmtIdUrl) {
              await fetchcheifcomplaintdata(patientid, apmtIdUrl);
            } else {
              await fetchcheifcomplaintdata(patientid);
            }
            showSuccessToast("CC deleted successfully.");
            deleteModal.current.closeModal();
            setDeleteId(null);
          } else {
            showErrorToast("Failed to delete CC.");
          }
        } catch (error) {
          console.error("Error deleting CC:", error);
          showErrorToast("Error deleting the CC.");
        } finally {
          dismissLoader();
        }
      };

  return (
    <>
      {isLoading && <Loader />}
      {/* <Box w="100%" display={{base: "none", lg: "block"}}> */}
      <Box w="100%">
        <Box>
        <Box pos='sticky' p='1rem 1.5rem' alignItems='center' top='0' zIndex='999' bg='white' borderBottom='1px solid #E6E7E9' display="flex" justifyContent="space-between" mb="10px">
          <Text fontWeight='600'>Chief Complaint</Text>
          {/* <PrimaryButton
            fontSize="14px"
            variant="mdBtn"
            btnIcon="/assets/imgs/add.png"
            buttonText="Add Medication"
            // onClick={addData}
            // isDisabled={actionAccessPatients?.create ? false : true}
          /> */}
        </Box>
        <Stepper
          orientation="vertical"
          // height="700px"
          height='calc(100vh - 160px)'
          overflow='hidden auto'
          padding='1rem'
          size="xs"
          colorScheme="#CDCFD4"
          // gap="0"
          gap='1rem'
          w="100%"
          justifyContent='flex-start'
          // orientation="vertical"
          // height="400px"
          // size="xs"
          // colorScheme="#CDCFD4"
          // gap="0"
          // w="100%"
        >
          {chiefComplaintData && chiefComplaintData.length>0 ? (
          chiefComplaintData.map((complaint,index) => (
            <Step w="100%" flex='unset' key={index}>
              <StepIndicator color="#E6E7E9" />

              <Box flexShrink="0" w="95%">
                <StepTitle as="div">
                  <Box display='flex' gap='1rem'>
                  <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{complaint.updateddate ? formatDate(complaint.updateddate) : formatDate(complaint.appointmentdate)}</Text>
                  {apmtIdUrl && (
                  <Box w='fit-content'>
                          {complaint.iscurrentvisit && complaint.iscurrentvisit === 1 ? (
                            <Text
                            fontSize="0.75rem"
                            borderRadius="full"
                            fontWeight="600"
                            p="0.25rem 0.5rem"
                            border="1px solid #E6E7E9"
                            // bg='#14C585'
                            bg='rgb(16, 185, 129)'
                            // bg="#E6E7E966"
                            // color='rgb(0,151,0)'
                          >
                            Current
                          </Text>
                          ) : (
                            <Text
                              fontSize="0.75rem"
                              borderRadius="full"
                              fontWeight="600"
                              p="0.25rem 0.5rem"
                              border="1px solid #E6E7E9"
                              // bg="#E6E7E966"
                              // color='rgb(255,165,0)'
                              bg="rgb(214, 158, 46)"
                              // color="#E6E7E966"
                            >
                              Past
                            </Text>
                          )}
                          </Box>
                  )}
                  </Box>
                  
                </StepTitle>
                <StepDescription
                  bg="white"
                  w="100%"
                  border="1px solid #E6E7E9"
                  borderRadius="0.65rem"
                  p="0.75rem"
                >
                  <Box display="flex" justifyContent="space-between" w="100%">
                    <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{`${complaint.updatedby || complaint.doctorname} , ${complaint.bookingid}`}</Text>
                    {/* <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{`${complaint.doctorname} , ${complaint.bookingid}`}</Text> */}
                    {apmtIdUrl && complaint.iscurrentvisit === 1 && (
                    <Box display="flex" gap="1.5rem" mr='1rem' cursor='pointer'>
                      <Box as="button" 
                      // disabled={actionAccessPatients?.update ? false : true}
                      // opacity={actionAccessPatients?.update ? 1 : 0.5} 
                      >
                        <Image 
                        src="/assets/svgs/edit.svg" 
                        w='1rem'
                        h='auto'
                        onClick={() => openEditModal(complaint)} 
                        />
                        </Box>
                        {/* <Box as="button" 
                        disabled={actionAccessPatients?.delete ? false : true}
                        opacity={actionAccessPatients?.delete ? 1 : 0.5} 
                        >
                        <Image 
                        src="/assets/svgs/delete.svg"
                        w='14px'
                        h='auto'
                        onClick={() => openDeleteModal(surgical.id, surgical.proceduretitle)}
                        />
                        </Box> */}
                    </Box>
                    )}
                  </Box>

                  <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{formatDate(complaint.appointmentdate)}</Text>

                  <Text fontSize="0.875rem" color="#384052" mb="0.5rem">{complaint.specialization}</Text>
                  {/* <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    p="0.5rem"
                    pl="0"
                  >
                    <Text fontSize="0.875rem" color="#061027">
                      Visited general physician
                      {complaint.doctorname}
                    </Text>
                    <Image src="/assets/imgs/right-icon.png" />
                  </Box> */}
                  <Box bg="#F9FAFB" borderLeft="2px solid #14C585" p="0.5rem">
                    <Text fontSize="0.875rem" fontWeight="500">
                      {/* Reason: Headache, stomach ache, coughing and vomiting */}
                      {complaint.chiefcomplaint}
                    </Text>
                  </Box>
                  {/* <Box display="flex" p="0.5rem" pl="0" alignItems="center">
                    <Image w="0.75rem" h="auto" src="/assets/svgs/update.svg" />
                    <Text
                      fontSize="0.875rem"
                      fontWeight="500"
                      color="#6A707D"
                      pl="0.5rem"
                    >
                      Reason: Headache, stomach ache, coughing and vomiting
                      {''}
                    </Text>
                  </Box> */}
                </StepDescription>
              </Box>
          <StepSeparator colorScheme="red" />

            </Step>
        ))
          ) : (
            <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            gap="10px"
                            alignItems="center"
                            h="calc(100vh - 100px)"
                            w="100%"
                          >
                            <Box textAlign="left" fontSize="16px" fontWeight="600">
                              <Image
                                w="26px"
                                opacity="0.5"
                                src="/assets/imgs/cheif-complaint.png"
                              />
                            </Box>
                            <Text textAlign="left" fontSize="12px" fontWeight="500">
                              No Data available
                            </Text>
                          </Box>
          )}
  
        </Stepper>
        </Box>
      </Box>

  {/* Update chief Complaint */}
      <DynamicModal
        ref={editComplaint}
        modalHeader={`Update Chief Complaint`}
        modalWidth='600px'
        modalBody={
          <>
            {/* <Box display="flex" py="20px">  */}
            <Box display="flex"> 
              <DatePicker
                // onDateChange={handledatechange}
                onDateChange={(selectedDateValue) =>
              handledatechange(selectedDateValue)
            }
                defaultDate={editData.date}
                value={editData.date}
                disableFutureDates={true}
                placeholderProp="Date"
                calendarStlye={{left: "-18px",  right: "unset"}}
              />
              <PrimaryInput
                variant="bothSide"
                id="vitaltime"
                inputType="time"
                inputPlace="Time"
                pr="10px"
                defaultValue={editData.time}
                inputValue={editData.time}
                onChange={handleTimeChange }
              />
            </Box>
            <Box display="flex" flexDir="column">
              <DropdownInput
                variant="bothSide"
                dropDownPlace="Doctor Name*"
                options={DoctorListForDropdown?DoctorListForDropdown:""}
                id="Doctor Name"
                onClick={HandleEditDoctor}
                // value={editData.updatedby || editData.doctorName} 
                // defaultOption={editData.updatedby || editData.doctorName}
                 value={editData.doctorName} // Use the doctorName from state
                defaultOption={editData.doctorName}
                menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
                inputStyleCss={{ w: "100%" }}
              />
            </Box>

            <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
              <Box
                as="form"
                width='100%'
                bg="white"
                pt={"2px"}
              >
                <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
                  <Textarea
                    borderRadius='0'
                    // placeholder="Instructions"
                    {...register("textField")}
                    // inputValue={updateCC}
                    value={updateCC}
                    onChange={handleTextChange}
                    height="100%"
                    padding="2"
                    resize="none"
                    // disabled={typing} // Disable when AI typing is true
                    style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                  />
                  
                  {!updateCC && (
                    <Text
                      position="absolute"
                      bottom="2"
                      left="50%"
                      transform="translateX(-50%)"
                      fontSize="sm"
                      color="gray.500"
                      w={{ base: "100%", md: "unset" }}
                      textAlign={{ base: "center", md: "unset" }}
                    >
                      {placeholder}
                    </Text>
                  )}
                </Box>
              </Box>
            </Box>
          </>
        }
        modalFooterBtn={
          <>
          <GPUChatAudioManagerSpeechMode
                  transcriber={activeTranscriber}
                  mode={mode}
                  setPlaceholder={setPlaceholder}
                  setTyping={setTyping}
                />
                <Box
                  as="button"
                  type="button" // Prevent form submission
                  border="1px solid #E6E7E9"
                  borderRadius="full"
                  w="36px"
                  h="auto"
                  p="10px"
                  mr='10px'
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  cursor={textFieldValue ? "pointer" : "not-allowed"}
                          opacity={textFieldValue ? 1 : 0.5}
                          pointerEvents={textFieldValue ? "auto" : "none"}
                          onClick={() => textFieldValue && correctOrders("edit")}
                >
                  <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
                </Box>
            <PrimaryButton
              // variant="deleteBtn"
              buttonText="Update Chief Complaint"
              btnStyle={{
                w: "100%",
                h: "2.5rem",
              }}
              onClick={editChiefComplaint}
            />
          </>
        }
      />

      {/* Mobile responsive */}
      <Box w="100%" display={{base: "block", lg: "none"}}>
      <MobileSecondaryNav
        header="Chief complaint"
        handlebackarrow={backFunction}
      />
      <Box h="calc(100vh - 120px)" overflow="hidden auto" p="1rem">
      <Stepper
          orientation="vertical"
          height="400px"
          size="xs"
          colorScheme="#CDCFD4"
          gap="0"
          w="100%"
        >
          {chiefComplaintData && chiefComplaintData.length>0 ? (
          chiefComplaintData.map((complaint,index) => (
            <Step w="100%" pb="1rem" key={index}>
              <StepIndicator color="#E6E7E9" />

              <Box flexShrink="0" w="95%">
                <StepTitle as="div">
                  {/* 10th Jan, 2024 */}
                  <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{formatDate(complaint.appointmentdate)}</Text>
                  <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{`${complaint.doctorname} , ${complaint.bookingid}`}</Text>
                  <Text fontSize="0.875rem" color="#384052" mb="0.5rem">{complaint.specialization}</Text>
                  
                </StepTitle>
                <StepDescription
                  bg="white"
                  w="100%"
                  border="1px solid #E6E7E9"
                  borderRadius="0.65rem"
                  p="0.75rem"
                >
                  {/* <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    p="0.5rem"
                    pl="0"
                  >
                    <Text fontSize="0.875rem" color="#061027">
                      Visited general physician
                      {complaint.doctorname}
                    </Text>
                    <Image src="/assets/imgs/right-icon.png" />
                  </Box> */}
                  <Box bg="#F9FAFB" borderLeft="2px solid #14C585" p="0.5rem">
                    <Text fontSize="0.875rem" fontWeight="500">
                      {/* Reason: Headache, stomach ache, coughing and vomiting */}
                      {complaint.chiefcomplaint}
                    </Text>
                  </Box>
                  {/* <Box display="flex" p="0.5rem" pl="0" alignItems="center">
                    <Image w="0.75rem" h="auto" src="/assets/svgs/update.svg" />
                    <Text
                      fontSize="0.875rem"
                      fontWeight="500"
                      color="#6A707D"
                      pl="0.5rem"
                    >
                      Reason: Headache, stomach ache, coughing and vomiting
                      {''}
                    </Text>
                  </Box> */}
                </StepDescription>
              </Box>
          <StepSeparator colorScheme="red" />

            </Step>
        ))
          ) : (
            <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            gap="10px"
                            alignItems="center"
                            h="calc(100vh - 100px)"
                            w="100%"
                          >
                            <Box textAlign="left" fontSize="16px" fontWeight="600">
                              <Image
                                w="26px"
                                opacity="0.5"
                                src="/assets/imgs/cheif-complaint.png"
                              />
                            </Box>
                            <Text textAlign="left" fontSize="12px" fontWeight="500">
                              No Data available
                            </Text>
                          </Box>
          )}
  
        </Stepper>
      </Box>
      </Box>
    </>
  );
};

export default ChiefComplaint;
  